import styled from 'styled-components';

export const StyledMapContainer = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
`;

export const StyledReportContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    z-index: 1300;
    width: 316px;
    height: 100vh;
    padding: ${({ theme }) => theme.spacing(2)}px;
    overflow-y: scroll;
    background: ${({ theme }) => theme.palette.colors.white};
    border-left: 1px solid ${({ theme }) => theme.palette.colors.grey100};
`;
